(() => {
  const styleId = 'ibh-shop-follow-button-style';

  const styleButton = (button) => {
    const shadowRoot = button.shadowRoot;

    if (!shadowRoot || shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      button,
      button span {
        font-family: var(--font-body--family) !important;
      }

      button,
      button > div:first-child {
        border-radius: 0 !important;
      }

      button > div:first-child {
        background-color: var(--color-button) !important;
      }

      button > span {
        font-size: 0.8rem !important;
        font-size: calc(0.8rem * var(--font-body--scale, 1)) !important;
        font-weight: 600 !important;
        letter-spacing: 0.02em !important;
        line-height: 1.2 !important;
      }

      button:hover > div:first-child {
        background-color: var(--color-links) !important;
      }

      button:focus-visible {
        outline: 2px solid var(--color-links);
        outline-offset: 3px;
      }
    `;

    shadowRoot.append(style);
  };

  const initialize = (root = document) => {
    customElements.whenDefined('shop-follow-button').then(() => {
      root.querySelectorAll('shop-follow-button').forEach(styleButton);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
